// extracted by mini-css-extract-plugin
module.exports = {"details":"_1rWQy0wTSz","details-dropdown":"_1pdlFK_xsn","detailsDropdown":"_1pdlFK_xsn","details-button":"_3GGzCjN0j9","detailsButton":"_3GGzCjN0j9"};
    if(module.hot) {
      // 1597843249781
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  